import { Input } from '@storeblocks/input';
import type { CleaveOptions } from 'cleave.js/options';
import Cleave from 'cleave.js/react';
import { Field, FieldProps } from 'formik';
import { FunctionComponent } from 'react';

interface Props
  extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  name: string;
  label: string;
  hint?: string;
  cleaveOptions?: CleaveOptions;
  alert?: { message?: string; messageType?: 'error' | 'warning' | 'success' };
  dataTest?: string;
}

export const FormInput: FunctionComponent<Props> = ({
  name,
  label,
  hint,
  cleaveOptions,
  alert,
  dataTest,
  ...props
}): JSX.Element => (
  <Field name={name}>
    {({ field }: FieldProps) => (
      <Input
        {...props}
        {...field}
        alert={alert}
        label={label}
        hint={{ text: hint }}
        data-test={dataTest}
        fluid
        // This will cause errors in the console, and it is expected.
        // This component will be replaced when the rewrite of the order pages is done.
        // The error will be of the type:
        // "Warning: Received `false` for a non-boolean attribute `fluid`."
        // Where the attribute can differ.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        as={cleaveOptions ? Cleave : undefined}
        options={cleaveOptions}
      />
    )}
  </Field>
);
